import { z } from 'zod'

export const signupDropoutGroupSchema = z.enum(['A', 'B'])
export type SignupDropoutGroup = z.infer<typeof signupDropoutGroupSchema>

/**
 * Response schema for signup-dropout promotion eligibility.
 */
export const signupDropoutPromotionSchema = z.object({
  eligible: z.boolean().describe('Promotion eligibility'),
  group: signupDropoutGroupSchema
    .nullable()
    .describe('Target group. A means trial not requested. B means trial requested but not completed.'),
  studentName: z.string().describe('Student name'),
})

export type SignupDropoutPromotion = z.infer<typeof signupDropoutPromotionSchema>

/**
 * Raw backend API response type in snake_case.
 */
export interface RawSignupDropoutPromotion {
  eligible: boolean
  group: SignupDropoutGroup | null
  student_name: string
}
